import Swiper from 'swiper'
import { Mousewheel, Navigation, Autoplay } from 'swiper/modules'

export default function () {
	document.addEventListener('DOMContentLoaded', function () {
		const sliderSectionEls = document.querySelectorAll('.section-slider')
		if (sliderSectionEls) {
			sliderSectionEls.forEach((sliderSectionEl) => {
				const id = sliderSectionEl.id
				new Swiper(sliderSectionEl as HTMLElement, {
					modules: [Navigation, Mousewheel, Autoplay],
					slidesPerView: 1,
					centeredSlides: true,
					loop: true,
					autoplay: {
						delay: 4000,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
					},
					navigation: {
						prevEl: `#${id} .prev`,
						nextEl: `#${id} .next`,
						disabledClass: 'btn-disabled',
					},
					mousewheel: {
						enabled: true,
						forceToAxis: true,
					},
				})
			})
		}
	})
}